function u(e, r) {
  var t = r.attribute;
  return e = e.replace(p, "&amp;").replace(a, "&gt;").replace(l, "&lt;"), t && (e = e.replace(c, "&apos;").replace(g, "&quot;")), e;
}
var p = /&/g, a = />/g, l = /</g, c = /'/g, g = /"/g;
export {
  u as default
};
//# sourceMappingURL=index.es498.js.map
